<div class="ot-row">
  <div class="otsc-prop-header">
    <h1 class="otsc-prop-header-text" i18n>Database</h1>
    <div class="ot-btn-group otsc-prop-header-btn">
      <button id="otsc-settings-database-update-btn" role="button" class="ot-btn ot-btn--is-primary" (click)="update()"
        [disabled]="!updatePasswordForm.dirty || updatePasswordForm.invalid || isSaving">
        {{savingBtn}}
      </button>
      <button id="otsc-settings-database-reset-btn" role="button" class="ot-btn ot-btn--is-secondary" (click)="reset()"
        [disabled]="!updatePasswordForm.dirty || isSaving" i18n>
        Reset
      </button>
    </div>
  </div>
</div>
@if (isInitialized) {
<div>
  @if (!isDBDefaultPwdChanged) {
  <div class="ot-message ot-message--is-warning">
    <div class="ot-message__banner">
      <p class="ot-pl-1" id="otsc-settings-database-default-pwd-msg" i18n>
        System Center Manager is currently configured with the default database password. For enhanced security, we
        strongly recommend updating the password.
      </p>
    </div>
  </div>
  }
  <form [formGroup]="updatePasswordForm" name="otsc-settings-database-form">
    <div class="ot-pt-1 ot-pb-1 ot-pl-1 ot-pr-2" style="height: calc(100vh - 150px);">
      <div class="ot-row">
        <div class="ot-col ot-row__column ot-row__column--is-33">
          @if (this.solutionInfo.settings.isDefaultDBPwdChanged) {
          <div class="ot-form-control"
            [ngClass]="{'ot-form-control--is-invalid' : !currentPasswordCtrl.pristine && currentPasswordCtrl.invalid}">
            <label class="ot-form-control__label" for="currentPassword" i18n>
              Current password
            </label>
            <div class="ot-form-control__input-group">
              <input id="currentPassword" formControlName="currentPasswordCtrl" placeholder="Enter current password"
                type="password" [minlength]="8" [maxLength]="60" class="ot-input ot-input--is-expanded">
            </div>
            @if (currentPasswordCtrl.errors?.required) {
            <p id="currentPasswordRequiredMsg" class="ot-form-control__error-text" i18n autocomplete="off" i18n>
              Current database password is required.
            </p>
            }
            @if (currentPasswordCtrl.errors?.minlength) {
            <p id="currentPasswordRequiredMsg" class="ot-form-control__error-text" i18n autocomplete="off" i18n>
              Minimum 8 characters required.
            </p>
            }
          </div>
          }
          <div class="ot-form-control"
            [ngClass]="{'ot-form-control--is-invalid' : !newPasswordCtrl.pristine && newPasswordCtrl.invalid}">
            <label class="ot-form-control__label" for="newPassword" i18n>
              New password
            </label>
            <div class="ot-form-control__input-group">
              <input id="newPassword" formControlName="newPasswordCtrl" placeholder="Enter new password" type="password"
                [minlength]="8" [maxLength]="60" class="ot-input ot-input--is-expanded">
            </div>
            @if (newPasswordCtrl.errors?.required) {
            <p id="currentPasswordRequiredMsg" class="ot-form-control__error-text" i18n autocomplete="off" i18n>
              New database password is required.
            </p>
            }
            @if (newPasswordCtrl.errors?.pattern) {
            <div id="currentPasswordRequiredMsg" class="ot-form-control__error-text" autocomplete="off" i18n>
              @if (!newPasswordCtrl.value.match('^(?=.*[A-Z])')) {
              <span>
                At least one uppercase letter is required.
              </span>
              }
              @else if (!newPasswordCtrl.value.match('(?=.*[a-z])')) {
              <span>
                At least one lower letter is required.
              </span>
              }
              @else if (!newPasswordCtrl.value.match('(.*[0-9].*)')) {
              <span>
                At least one number is required.
              </span>
              }@else if (!newPasswordCtrl.value.match('(?=.*[@$#!%*&^])')) {
              <span>
                At least one special character (&#64;$#!%*&^) is required.
              </span>
              }@else if (!newPasswordCtrl.value.match('.{8,}')) {
              <span>
                At least 8 characters are required.
              </span>
              }@else {
              <span>
                Invalid character was found.
              </span>
              }
            </div>
            }
            <p class="ot-form-control__info-text" i18n>A new password should be at least 8 characters long and include
              uppercase and lowercase letters, numbers, and special characters (&#64;$#!%*&^).</p>
          </div>
          <div class="ot-form-control"
            [ngClass]="{'ot-form-control--is-invalid' : !confirmNewPasswordCtrl.pristine && updatePasswordForm.invalid}">
            <label class="ot-form-control__label" for="confirmNewPassword" i18n>
              Confirm new password
            </label>
            <div class="ot-form-control__input-group">
              <input id="confirmNewPassword" formControlName="confirmNewPasswordCtrl" placeholder="Confirm new password"
                type="password" [maxLength]="60" class="ot-input ot-input--is-expanded">
            </div>
            @if (updatePasswordForm.errors?.passwordNotSame) {
            <p id="currentPasswordRequiredMsg" class="ot-form-control__error-text" i18n autocomplete="off" i18n>
              New database password doesn't match.
            </p>
            }
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
}